module.exports = __webpack_public_path__ + "static/media/Cluster-6_switch.d80e0e1c.gif";